var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLandingBackground3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 90,
    viewBox: "0 0 91 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1769 24.6064C34.299 33.924 48.4754 43.1109 63.3267 52.8848C61.4178 53.2398 59.6614 53.9646 58.2089 53.5904C52.8064 52.0335 46.8171 51.1515 42.3274 48.1361C34.8064 43.018 28.2362 36.534 21.5031 30.4417C20.1151 29.1755 19.5914 27.1198 18.6436 25.3473C19.1982 25.1185 19.6604 24.9277 20.1769 24.6064Z",
    fill: "#F7C034"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0328 66.9364C48.2279 67.8486 47.4135 69.5418 46.555 69.5954C40.4334 69.675 34.3408 69.4733 28.3258 69.2084C27.4818 69.1214 26.1766 67.9916 25.9822 67.1185C25.851 66.3231 26.8351 64.363 27.2571 64.4066C34.2082 64.5547 41.2079 64.921 48.2852 65.2243C48.5085 65.816 48.7319 66.4078 49.0328 66.9364Z",
    fill: "#F7C034"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1038 19.5821C62.8632 26.7626 67.2025 33.383 71.6819 40.0234C74.1825 34.0236 65.0239 19.1428 58.1038 19.5821Z",
    fill: "#F7C034"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingBackground3);
export default __webpack_public_path__ + "static/media/landingBackground3.097690f6eb569e74804614c6f937a2fe.svg";
export { ForwardRef as ReactComponent };